const Constants = {
    APPLY_TIMELINE_CONFIG: 'APPLY_TIMELINE_CONFIG',
    APPLY_USER_TIMELINE_CONFIG: 'APPLY_USER_TIMELINE_CONFIG',
    SET_ERROR: 'SET_ERROR'
}

export default Constants
